import React from 'react';

function ChevronUpIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9,4.7c0.6-0.6,1.5-0.6,2,0l8.6,8.6c0.6,0.6,0.6,1.5,0,2c-0.6,0.6-1.5,0.6-2,0L10,7.7l-7.6,7.6c-0.6,0.6-1.5,0.6-2,0c-0.5-0.6-0.6-1.5,0-2L9,4.7L9,4.7z"/>
    </svg>
  );
}

export default ChevronUpIcon;
